
import SelectDesign from "@/components/base/form/SelectDesign.vue";
import DateRange from "@/components/base/pickers/DateRange.vue";
import { IFilter } from "@/types";
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

@Component({
    components: { SelectDesign, DateRange },
})
export default class ReportFilterByDate extends Vue {
    @PropSync('filter', { required: true }) filterSync!: IFilter;
    @PropSync('compareFilter', { default: () => ({ select: [] }) }) compareFilterSync!: { select: string[]; periodTemplate: string };
    @PropSync('isCompare') isCompareSync!: boolean;
    @Prop({ type: String, default: 'Сформировать' }) readonly submitBtnText!: string;
    @Prop({ type: Boolean, default: false }) readonly isCompareMode!: boolean;
    @Prop({ default: undefined }) groupFilter!: IFilter;
    @Prop({ default: false }) readonly isDisabledSubmit!: boolean;
    @Prop({ default: false }) readonly isTop!: boolean;
    @Prop({ default: true }) readonly isTrashBtn!: boolean;
    @Prop({ default: true }) readonly isSubmitBtn!: boolean;
    @Prop({ default: false }) readonly isShowOuterGrouping!: boolean;
    @Prop({ default: false }) readonly isFullWidth!: boolean;

    get indexSelect(): string {
        return this.$vuetify.breakpoint.width <= 890 ? '' : 'Дата';
    }
}
